import { Card } from "@/components/ui/card";
import { Car, Home, Sailboat, Truck, User } from "lucide-react";

interface ClaimTypeStepProps {
  selectedType: string;
  onTypeSelect: (type: string) => void;
}

export const ClaimTypeStep = ({ selectedType, onTypeSelect }: ClaimTypeStepProps) => {
  const claimTypes = [
    { icon: Car, label: "Auto" },
    { icon: Home, label: "Home" },
    { icon: Sailboat, label: "Watercraft" },
    { icon: Car, label: "RV" },
    { icon: Car, label: "Motorcycle" },
    { icon: Truck, label: "Commercial Auto" },
    { icon: User, label: "Life" },
  ];

  return (
    <div>
      <h3 className="text-lg font-medium text-primary-dark mb-4">
        What type of claim are you reporting?
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {claimTypes.map((type) => (
          <Card 
            key={type.label}
            className={`p-4 transition-colors cursor-pointer flex items-center space-x-3 ${
              selectedType === type.label ? 'border-primary bg-primary/5' : 'hover:border-primary'
            }`}
            onClick={() => onTypeSelect(type.label)}
          >
            <div className="p-2 bg-[#F1F0FB] rounded-lg">
              <type.icon className="h-6 w-6 text-primary" />
            </div>
            <span className="font-medium text-primary-dark">
              {type.label}
            </span>
          </Card>
        ))}
      </div>
    </div>
  );
};